import { tabletQuery } from '@globals/themes/themeConstants'
import { SxProps } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import { FC, PropsWithChildren, ReactNode } from 'react'
import BottomDrawer from './BottomDrawer'
import { CustomDialog } from './CustomDialog'

type DesktopDialogWithMobileDrawerProps = PropsWithChildren & {
  dialogKey: string
  onClose?: () => void
  onBeforeClose?: (doClose: () => void) => boolean
  title?: ReactNode
  drawerStyles?: SxProps
  minDialogHeight?: string | number
  maxDialogHeight?: string | number
  maxDialogWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined
  backgroundColor?: string
  showTitle?: boolean
  disableAutoFocus?: boolean
  disableEnforceFocus?: boolean
}
const DesktopDialogWithMobileDrawer: FC<DesktopDialogWithMobileDrawerProps> = ({
  dialogKey,
  children,
  onClose,
  onBeforeClose,
  title,
  drawerStyles,
  minDialogHeight,
  maxDialogHeight,
  maxDialogWidth,
  backgroundColor,
  showTitle,
  disableAutoFocus = false,
  disableEnforceFocus = false,
}) => {
  const isTablet = useMediaQuery(tabletQuery)

  return isTablet ? (
    <BottomDrawer
      drawerKey={dialogKey}
      onClose={() => {
        if (onBeforeClose && onClose) {
          return onBeforeClose(onClose)
        }
        onClose?.()
      }}
      title={title}
      disableAutoFocus={disableAutoFocus}
      disableEnforceFocus={disableEnforceFocus}
      backgroundColor={backgroundColor}
      drawerStyles={drawerStyles}>
      {children}
    </BottomDrawer>
  ) : (
    <CustomDialog
      dialogKey={dialogKey}
      onClose={() => {
        if (onBeforeClose && onClose) {
          return onBeforeClose(onClose)
        }
        onClose?.()
      }}
      title={title}
      minHeight={minDialogHeight}
      maxHeight={maxDialogHeight}
      maxWidth={maxDialogWidth}
      backgroundColor={backgroundColor}
      disableAutoFocus={disableAutoFocus}
      disableEnforceFocus={disableEnforceFocus}
      showTitle={showTitle}>
      {children}
    </CustomDialog>
  )
}

export default DesktopDialogWithMobileDrawer
